<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <application-info></application-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9">
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('medium_grant_ev.revision__technical_description_changes')}}</p>

            <radio name="model.rev_technical_changes" value="accepted" v-model="EvaluationForm.model.rev_technical_changes" @input="handleRevTechnicalChange">
              {{$t('medium_grant_ev.revision__accepted')}}
            </radio>
            <radio name="model.rev_technical_changes" value="needs-more" v-model="EvaluationForm.model.rev_technical_changes" @input="handleRevTechnicalChange">
              {{$t('medium_grant_ev.revision__need_further_and_changes')}}
            </radio>
            <radio name="model.rev_technical_changes" value="not-accepted" v-model="EvaluationForm.model.rev_technical_changes" @input="handleRevTechnicalChange">
              {{$t('medium_grant_ev.revision__not_accepted')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_technical_changes_clearance_by && EvaluationForm.model.rev_technical_changes_clearance_by.user">
              <div>{{EvaluationForm.model.rev_technical_changes_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_technical_changes_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_technical_changes" :comments="EvaluationForm.model.comments_rev_technical_changes" :pull-right="false"></comment-box>
          </div>

          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('medium_grant_ev.revision__revised_budget')}}</p>

            <radio name="model.rev_revised_budget" value="accepted" v-model="EvaluationForm.model.rev_revised_budget" @input="handleRevBudgetChange">
              {{$t('medium_grant_ev.revision__accepted')}}
            </radio>
            <radio name="model.rev_revised_budget" value="needs-more" v-model="EvaluationForm.model.rev_revised_budget" @input="handleRevBudgetChange">
              {{$t('medium_grant_ev.revision__need_further_and_changes')}}
            </radio>
            <radio name="model.rev_revised_budget" value="not-accepted" v-model="EvaluationForm.model.rev_revised_budget" @input="handleRevBudgetChange">
              {{$t('medium_grant_ev.revision__not_accepted')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_revised_budget_clearance_by && EvaluationForm.model.rev_revised_budget_clearance_by.user">
              <div>{{EvaluationForm.model.rev_revised_budget_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_revised_budget_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_revised_budget" :comments="EvaluationForm.model.comments_rev_revised_budget" :pull-right="false"></comment-box>
          </div>

          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('medium_grant_ev.revision__revised_esms')}}</p>

            <radio name="model.rev_revised_esms" value="cleared" v-model="EvaluationForm.model.rev_revised_esms" @input="handleRevEsmsChange">
              {{$t('medium_grant_ev.revision__cleared')}}
            </radio>
            <radio name="model.rev_revised_esms" value="needs-more" v-model="EvaluationForm.model.rev_revised_esms" @input="handleRevEsmsChange">
              {{$t('medium_grant_ev.revision__need_further')}}
            </radio>
            <radio name="model.rev_revised_esms" value="not-cleared" v-model="EvaluationForm.model.rev_revised_esms" @input="handleRevEsmsChange">
              {{$t('medium_grant_ev.revision__not_cleared')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_revised_esms_clearance_by && EvaluationForm.model.rev_revised_esms_clearance_by.user">
              <div>{{EvaluationForm.model.rev_revised_esms_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_revised_esms_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_revised_esms" :comments="EvaluationForm.model.comments_rev_revised_esms" :pull-right="false"></comment-box>
          </div>

        </div>

      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import ApplicationInfo from './ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        loggedUser: {},
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_MG_ESMS_Clearance_Template_checklist_I_FINAL_Nov_2019.docx',
          fr: '/files/en/BIOPAMA_AC_MG_ESMS_Clearance_Template_checklist_I_FINAL_Nov_2019.docx'
        }
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.revision) {
        EvaluationForm.files.revision = {};
      }
    },
    beforeMount()
    {
      let vm = this;

      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      handleRevTechnicalChange()
      {
        // if (!EvaluationForm.model.rev_technical_changes_clearance_by || !EvaluationForm.model.rev_technical_changes_clearance_by.user)
        {
          let current_date = new Date();

          current_date.setHours(current_date.getHours() + 1);
          current_date = current_date.toJSON().slice(0, 19).replace('T', ' ');

          EvaluationForm.model.rev_technical_changes_clearance_by = {
            user: this.loggedUser,
            updated_at: current_date
          };
        }
      },
      handleRevBudgetChange()
      {
        // if (!EvaluationForm.model.rev_revised_budget_clearance_by || !EvaluationForm.model.rev_revised_budget_clearance_by.user)
        {
          let current_date = new Date();

          current_date.setHours(current_date.getHours() + 1);
          current_date = current_date.toJSON().slice(0, 19).replace('T', ' ');

          EvaluationForm.model.rev_revised_budget_clearance_by = {
            user: this.loggedUser,
            updated_at: current_date
          };
        }
      },
      handleRevEsmsChange()
      {
        // if (!EvaluationForm.model.rev_revised_esms_clearance_by || !EvaluationForm.model.rev_revised_esms_clearance_by.user)
        {
          let current_date = new Date();

          current_date.setHours(current_date.getHours() + 1);
          current_date = current_date.toJSON().slice(0, 19).replace('T', ' ');

          EvaluationForm.model.rev_revised_esms_clearance_by = {
            user: this.loggedUser,
            updated_at: current_date
          };
        }
      },
    }
  }
</script>
<style>
  a.link-download {
    text-decoration: underline;
  }
</style>
